import { IJobApplication } from '../interfaces/job.interfaces';
import { JobApplicationStatusUpdateValues } from '../consts/jobApplication.consts';

export const scaleScores = (score: number, scale?: number) => {
    const scaledScore = (score / (scale || 100)) * 10;
    return Math.round(scaledScore);
};

export const isFirstStepInProcess = (jobApplication: IJobApplication): boolean => {
    return !!(
        jobApplication.steps &&
        jobApplication.steps.length > 0 &&
        jobApplication.steps[0].status === JobApplicationStatusUpdateValues.inProcess
    );
};
